import qs from 'qs'

const BASE_URL = 'ai-service/api/prediction-sets'

const predictionSetsRequests = {
  addPredictionSetRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  updatePredictionSetRequest: (data) => ({
    url: BASE_URL,
    method: 'put',
    data,
  }),
  deletePredictionSetRequest: (predictionSetId) => ({
    url: `${BASE_URL}/${predictionSetId}`,
    method: 'delete',
  }),
  getPredictionSetsRequest: ({
    pageNumber = 1,
    pageSize = 25,
    order = 'asc',
    orderBy = 'CreatedOn',
    filters = { Name: '', Description: '', Type: null, AIObjects: [] },
  }) => ({
    url: BASE_URL,
    method: 'get',
    params: {
      pageNumber,
      pageSize,
      column: orderBy,
      order,
      Name: filters.Name,
      Description: filters.Description,
      Type: filters.Type,
      AIObjects: filters.AIObjects,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  }),

  getPredictionSetRequest: ({ predictionSetId }) => ({
    url: `${BASE_URL}/${predictionSetId}`,
    method: 'get',
  }),
}

export default predictionSetsRequests
